<template>
  <div class="page">
    <v-container grid-list-md>

      <v-layout row wrap>
        <v-flex xs12 md6>

          <div class="myBox bgw">
            <div class="d-flex align-center">

              <v-icon x-large class="myAccent">mdi-clock-outline</v-icon>
              <!--                            <v-icon x-large class="myAccent">mdi-clock-outline</v-icon>-->
              <!--                            <v-icon x-large class="myAccent">mdi-coffee-to-go-outline</v-icon>-->
              <h3 class="ml-2 fontColor">Lieferzeiten</h3>
            </div>


            <div v-if="$store.getters.appconfig.loaded">
              <div class="mt-4" style="font-size: 1.2em">
<!--                <h4 class="mb-1">Lieferzeiten</h4>-->
                <oeffnungszeiten
                  :opening-hours="$store.getters.appconfig.delivery.openingHours"></oeffnungszeiten>
              </div>
              <!--                            <div class="mt-4" v-if="$store.getters.appconfig.loaded">-->
              <!--                                <h4 class="mb-1">Vorlaufzeit für Bestellungen</h4>-->
              <!--                                <div>{{$store.getters.appconfig.delayInMinutes}} Minuten</div>-->
              <!--                            </div>-->
              <!--                            <div class="mt-4">-->
              <!--                                <h4 class="mb-1">Abholadresse</h4>-->
              <!--                                <div>-->
              <!--                                    &lt;!&ndash;                                            <h4 class="d-inline-block">Anschrift:  </h4>&ndash;&gt;-->
              <!--                                    &lt;!&ndash;                                    {{$store.state.brandName}}<br>&ndash;&gt;-->
              <!--                                    {{$store.state.staticDisplayAbholung}}-->
              <!--                                    &lt;!&ndash;                        Sudhaus<br>&ndash;&gt;-->
              <!--                                    &lt;!&ndash;                        Dieplohstraße 12<br>&ndash;&gt;-->
              <!--                                    &lt;!&ndash;                        59581 Warstein<br>&ndash;&gt;-->
              <!--                                </div>-->
              <!--                            </div>-->

              <div style="padding: 0 5px">
                <v-btn
                  class="text-none mt-8 mb-2 btn-df"
                  block
                  @click.native.passive="$ebus.$emit('shortcutToFoodMenu')"
                >
                  Jetzt bestellen!
                </v-btn>
              </div>
            </div>


            <div v-else class="text-center">
              <v-progress-circular indeterminate size="34"></v-progress-circular>
              <!--                            <div class="myDisplay1">LOADING</div>-->
            </div>

          </div>

        </v-flex>

        <v-flex xs12 md6>

          <Zahlungsarten :noborder="true"></Zahlungsarten>

        </v-flex>

      </v-layout>


    </v-container>
  </div>
</template>

<script>
// import {ebus} from '../vendor/ebus';
import store from '../store/store'
import Oeffnungszeiten from "@/components/oeffnungszeiten.vue";
import Zahlungsarten from "@/components/Zahlungsarten.vue";

export default {
  // mixins: [offerMixin],
  components: {
    Zahlungsarten,
    Oeffnungszeiten
  },
  data() {
    return {}
  },
  computed: {},
  methods: {}

}
</script>
<style scoped lang="scss">
@import '../styles/base';

.myBox {
  text-align: left;
  border: 3px solid $accent;
  padding: 2.5vw;
  margin: 10px;
  border-radius: $box-border-radius;
}

</style>
